// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-list__item{
    padding-bottom: 1rem;
    width: 100%;
}

.settings-list__breaker{
    width: 30%;
    border-color: rgba(0, 0, 0, 0.10);
    border-top: none;
}

.settings-list__item .select-rental-object-container{
    padding-bottom: 1rem;
}
.settings-list__item .rental-agreement__status{
    font-weight: 600;
    display: block;
    width: 100%;
    text-align: center;
    cursor: pointer;
    text-decoration: underline;
}
 .rental-agreement__status--active{
     color: var(--app-fill-color-success);
     text-decoration-color: var(--app-fill-color-success)!important;
 }

 .rental-agreement__status--active{

    color: var(--app-fill-color-success);
    text-decoration-color: var(--app-fill-color-success)!important;
}

.rental-agreement__status--inactive{

    color: var(--app-fill-color-primary--danger);
    text-decoration-color: var(--app-fill-color-primary--danger)!important;
}
.settings-list__user-data fieldset > legend,
.settings-list__item .MuiInputLabel-root.MuiFormLabel-root{
    transform: translate(14px, 9px) scale(0.75)!important;
    background-color: var(--app-primary-bg-color-white);
    width: fit-content;
}
.settings-list__item fieldset,
.settings-list__item .PrivateNotchedOutline-root-1{
    z-index: -1;
}
.settings-list__user-data{
    width: 100%;
    font-weight: var(--app-font-weigth--600);

}
.settings-list__user-data .MuiInputLabel-root.MuiFormLabel-root{ transform: translate(14px, -7px) scale(0.75)!important;}

.setting-list__item.setting-list__version {
    position: absolute;
    bottom: 2rem;
    width: 100%;
    text-align: center;
    right: 0;
    font-size: 0.75rem;
    color: var(--app-border-secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/components/SettingsList/styles/SettingsList.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;CACC;KACI,oCAAoC;KACpC,8DAA8D;CAClE;;CAEA;;IAEG,oCAAoC;IACpC,8DAA8D;AAClE;;AAEA;;IAEI,4CAA4C;IAC5C,sEAAsE;AAC1E;AACA;;IAEI,qDAAqD;IACrD,mDAAmD;IACnD,kBAAkB;AACtB;AACA;;IAEI,WAAW;AACf;AACA;IACI,WAAW;IACX,wCAAwC;;AAE5C;AACA,iEAAiE,sDAAsD,CAAC;;AAExH;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,wCAAwC;AAC5C","sourcesContent":[".settings-list__item{\n    padding-bottom: 1rem;\n    width: 100%;\n}\n\n.settings-list__breaker{\n    width: 30%;\n    border-color: rgba(0, 0, 0, 0.10);\n    border-top: none;\n}\n\n.settings-list__item .select-rental-object-container{\n    padding-bottom: 1rem;\n}\n.settings-list__item .rental-agreement__status{\n    font-weight: 600;\n    display: block;\n    width: 100%;\n    text-align: center;\n    cursor: pointer;\n    text-decoration: underline;\n}\n .rental-agreement__status--active{\n     color: var(--app-fill-color-success);\n     text-decoration-color: var(--app-fill-color-success)!important;\n }\n\n .rental-agreement__status--active{\n\n    color: var(--app-fill-color-success);\n    text-decoration-color: var(--app-fill-color-success)!important;\n}\n\n.rental-agreement__status--inactive{\n\n    color: var(--app-fill-color-primary--danger);\n    text-decoration-color: var(--app-fill-color-primary--danger)!important;\n}\n.settings-list__user-data fieldset > legend,\n.settings-list__item .MuiInputLabel-root.MuiFormLabel-root{\n    transform: translate(14px, 9px) scale(0.75)!important;\n    background-color: var(--app-primary-bg-color-white);\n    width: fit-content;\n}\n.settings-list__item fieldset,\n.settings-list__item .PrivateNotchedOutline-root-1{\n    z-index: -1;\n}\n.settings-list__user-data{\n    width: 100%;\n    font-weight: var(--app-font-weigth--600);\n\n}\n.settings-list__user-data .MuiInputLabel-root.MuiFormLabel-root{ transform: translate(14px, -7px) scale(0.75)!important;}\n\n.setting-list__item.setting-list__version {\n    position: absolute;\n    bottom: 2rem;\n    width: 100%;\n    text-align: center;\n    right: 0;\n    font-size: 0.75rem;\n    color: var(--app-border-secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
